_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[29],{

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j36g");
module.exports = __webpack_require__("vlRD");


/***/ }),

/***/ "3niX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.flush = flush;
exports["default"] = void 0;

var _react = __webpack_require__("q1tI");

var _stylesheetRegistry = _interopRequireDefault(__webpack_require__("SevZ"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var styleSheetRegistry = new _stylesheetRegistry["default"]();

var JSXStyle = /*#__PURE__*/function (_Component) {
  _inheritsLoose(JSXStyle, _Component);

  function JSXStyle(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.prevProps = {};
    return _this;
  }

  JSXStyle.dynamic = function dynamic(info) {
    return info.map(function (tagInfo) {
      var baseId = tagInfo[0];
      var props = tagInfo[1];
      return styleSheetRegistry.computeId(baseId, props);
    }).join(' ');
  } // probably faster than PureComponent (shallowEqual)
  ;

  var _proto = JSXStyle.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(otherProps) {
    return this.props.id !== otherProps.id || // We do this check because `dynamic` is an array of strings or undefined.
    // These are the computed values for dynamic styles.
    String(this.props.dynamic) !== String(otherProps.dynamic);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    styleSheetRegistry.remove(this.props);
  };

  _proto.render = function render() {
    // This is a workaround to make the side effect async safe in the "render" phase.
    // See https://github.com/zeit/styled-jsx/pull/484
    if (this.shouldComponentUpdate(this.prevProps)) {
      // Updates
      if (this.prevProps.id) {
        styleSheetRegistry.remove(this.prevProps);
      }

      styleSheetRegistry.add(this.props);
      this.prevProps = this.props;
    }

    return null;
  };

  return JSXStyle;
}(_react.Component);

exports["default"] = JSXStyle;

function flush() {
  var cssRules = styleSheetRegistry.cssRules();
  styleSheetRegistry.flush();
  return cssRules;
}

/***/ }),

/***/ "8ujH":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__("NOtv")('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ "9kyW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),

/***/ "KMK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_POSTS_QUERY; });
/* harmony import */ var _babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("h4VS");
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lTCR");
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_1__);


function _templateObject() {
  var data = Object(_babel_runtime_helpers_esm_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(["\n  query ALL_POSTS_QUERY($cursor: String, $first: Int = 10) {\n    posts: posts(first: $first, after: $cursor) {\n      edges {\n        node {\n          revisionCount\n          id\n          title\n          link: uri\n          date\n          commentCount\n          featuredImage {\n            node {\n              mediaDetails {\n                sizes {\n                  name\n                  sourceUrl\n                  width\n                  height\n                }\n              }\n            }\n          }\n          categories {\n            edges {\n              node {\n                name\n                slug\n              }\n            }\n          }\n          excerpt(format: RAW)\n          author {\n            node {\n              name\n              slug\n            }\n          }\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}


var ALL_POSTS_QUERY = graphql_tag__WEBPACK_IMPORTED_MODULE_1___default()(_templateObject());

/***/ }),

/***/ "L+h+":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():undefined}("undefined"!=typeof self?self:this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function o(e,t,n){if("object"===(void 0===t?"undefined":i(t))){return""+u(t,""+n+(""+e+(n&&"]")+"["))}return n&&n.length?""+n+e+"]="+encodeURIComponent(t):e+"="+encodeURIComponent(t)}function r(e,t,n){return t.map(function(t){return o(e,t,n)}).join("&")}function u(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},u=n.arrayPrefix||"",i=[];return i=Array.isArray(e)?e.map(function(e,n){return o(""+n+u,e,t)}):Object.keys(e).filter(function(t){return void 0!==e[t]}).map(function(n){return e[n]&&Array.isArray(e[n])?r(""+n+u,e[n],t):o(n,e[n],t)}),i.join("&").replace(/%20/g,"+")}Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=u}])});

/***/ }),

/***/ "MX0m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("3niX")


/***/ }),

/***/ "RNiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@apollo/react-components/lib/react-components.esm.js
var react_components_esm = __webpack_require__("vbcS");

// EXTERNAL MODULE: ./components/ErrorMessage.js
var ErrorMessage = __webpack_require__("VUBQ");

// EXTERNAL MODULE: ./components/Teaser.js
var Teaser = __webpack_require__("KIk8");

// EXTERNAL MODULE: ./components/Layout/PostGrid.js
var PostGrid = __webpack_require__("+Hjb");

// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__("RotF");
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__("h4VS");

// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__("lTCR");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./util/markup.js
var markup = __webpack_require__("jZu3");

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__("kriW");

// CONCATENATED MODULE: ./components/PostList/WeSelect.js




function _templateObject() {
  var data = Object(taggedTemplateLiteral["a" /* default */])(["\n  query WE_SELECT_QUERY {\n    we_selects(\n      first: 3\n      where: { orderby: { field: DATE, order: DESC }, author: 2 }\n    ) {\n      edges {\n        node {\n          content(format: RAW)\n          image\n          shoppingUrl\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}







var WE_SELECT_QUERY = src_default()(_templateObject());
var WeSelectWrapper = styled_components_browser_esm["default"].section.withConfig({
  displayName: "WeSelect__WeSelectWrapper",
  componentId: "ql9s5d-0"
})(["max-width:", ";margin:5rem auto;h2{", ";text-align:center;font-size:3rem;margin-bottom:2rem;@media screen and (max-width:500px){font-size:2rem;}}> p{text-align:center;font-size:2rem;}"], function (props) {
  return props.theme.maxWidth;
}, function (props) {
  return props.theme.fontSerif;
});
var WeSelectProducts = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WeSelect__WeSelectProducts",
  componentId: "ql9s5d-1"
})(["display:grid;grid-template-columns:repeat(3,1fr);grid-gap:5rem;@media screen and (max-width:500px){grid-gap:1rem;grid-template-columns:1fr;}margin:2rem 10%;div{text-align:center;img{width:100%;@media screen and (max-width:500px){width:75%;}object-fit:cover;}a{", ";display:block;padding:1rem;@media screen and (max-width:500px){padding:10px;}font-size:1.5rem;min-height:14rem;margin-bottom:0;line-height:24px;}a.buy-now{min-height:1rem;font-weight:bold;", ";color:", ";font-size:1.5rem;font-style:italic;span{font-size:2rem;}}}"], function (props) {
  return props.theme.fontSerif;
}, function (props) {
  return props.theme.fontSerif;
}, function (props) {
  return props.theme.highlight;
});

var WeSelect_WeSelect = function WeSelect() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(react_components_esm["b" /* Query */], {
    query: WE_SELECT_QUERY,
    ssr: false,
    children: function children(_ref) {
      var _data$we_selects;

      var data = _ref.data,
          error = _ref.error,
          loading = _ref.loading;
      if (loading) return null;
      if (error) return null;

      if (!(data === null || data === void 0 ? void 0 : (_data$we_selects = data.we_selects) === null || _data$we_selects === void 0 ? void 0 : _data$we_selects.edges)) {
        return null;
      }

      if (data.we_selects.edges.length === 0) {
        return null;
      }

      return /*#__PURE__*/Object(jsx_runtime["jsxs"])(WeSelectWrapper, {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
          children: "Shopping: We Select"
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(message["a" /* default */], {
            id: "weselect.kathrin",
            defaultMessage: "Kathrins Empfehlungen"
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(WeSelectProducts, {
          children: data.we_selects.edges.map(function (_ref2, index) {
            var node = _ref2.node;
            return /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                target: "_blank",
                href: node.shoppingUrl,
                rel: "noopener noreferrer",
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])("img", {
                  src: node.image,
                  alt: node.content
                })
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                target: "_blank",
                href: node.shoppingUrl,
                rel: "noopener noreferrer",
                dangerouslySetInnerHTML: Object(markup["b" /* createMarkup */])(node.content)
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                className: "buy-now",
                target: "_blank",
                href: node.shoppingUrl,
                rel: "noopener noreferrer",
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])(message["a" /* default */], {
                  id: "weselect.convinced",
                  defaultMessage: "\xDCberzeugt, nehm ich!"
                })
              })]
            }, "we-select-".concat(index));
          })
        })]
      });
    }
  });
};

/* harmony default export */ var PostList_WeSelect = (WeSelect_WeSelect);
// EXTERNAL MODULE: ./components/PostList/Ticker.js + 3 modules
var Ticker = __webpack_require__("et8y");

// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__("VFWX");

// EXTERNAL MODULE: ./components/PostList/Newsletter.js + 2 modules
var Newsletter = __webpack_require__("Y8fK");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./lib/wordpress.js
var wordpress = __webpack_require__("xWpn");

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__("ttZb");

// CONCATENATED MODULE: ./components/PostList/TagTeaser.js





function TagTeaser_templateObject() {
  var data = Object(taggedTemplateLiteral["a" /* default */])(["\n  query POSTS_BY_TAG_QUERY($tag: String) {\n    tag: tags(where: { slug: [$tag] }) {\n      edges {\n        node {\n          slug\n          name\n        }\n      }\n    }\n    tagPosts: posts(where: { tag: $tag }, first: 5) {\n      edges {\n        node {\n          id\n          featuredImage {\n            node {\n              mediaDetails {\n                sizes {\n                  name\n                  sourceUrl\n                  width\n                  height\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"]);

  TagTeaser_templateObject = function _templateObject() {
    return data;
  };

  return data;
}






var POSTS_BY_TAG_QUERY = src_default()(TagTeaser_templateObject());
var TrendsTeaserStyles = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TagTeaser__TrendsTeaserStyles",
  componentId: "sc-1yp6b4p-0"
})(["position:relative;> div.wrapper{height:300px;width:100%;display:flex;}h1{position:absolute;top:0px;bottom:0px;width:100%;margin-top:140px;@media (max-width:400px){margin-top:70px;}text-align:center;}h1 a{display:block;color:white;font-size:7rem;font-weight:normal;text-shadow:0 1px 0 black;text-align:center;@media (max-width:700px){text-align:center;font-size:5rem;line-height:7rem;}}"]);
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TagTeaser__ImageContainer",
  componentId: "sc-1yp6b4p-1"
})(["background-position:center;background-repeat:no-repeat;background-size:cover;overflow:hidden;width:100%;height:300px;"]);

var _StyledImageContainer = Object(styled_components_browser_esm["default"])(ImageContainer).withConfig({
  displayName: "TagTeaser___StyledImageContainer",
  componentId: "sc-1yp6b4p-2"
})(["background-image:url(", ");"], function (p) {
  return p._css;
});

var TagTeaser_TagTeaser = function TagTeaser(_ref) {
  var tagName = _ref.tagName;

  var _useQuery = Object(react_hooks_esm["c" /* useQuery */])(POSTS_BY_TAG_QUERY, {
    variables: {
      tag: tagName
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (error) {
    return null;
  }

  if (loading) {
    return null;
  }

  var tag = data.tag,
      tagPosts = data.tagPosts;
  var posts = tagPosts.edges;

  if (tag.edges.length === 0) {
    return null;
  }

  var tagResult = tag.edges[0].node;
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(TrendsTeaserStyles, {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
      className: "wrapper",
      children: posts.map(function (_ref2) {
        var node = _ref2.node;
        var teaserImage = Object(wordpress["c" /* getImageSize */])(node.featuredImage.node.mediaDetails.sizes, "post-thumbnail");

        if (!teaserImage) {
          teaserImage = Object(wordpress["c" /* getImageSize */])(node.featuredImage.node.mediaDetails.sizes, "thumbnail");
        }

        if (!teaserImage) {
          teaserImage = Object(wordpress["c" /* getImageSize */])(node.featuredImage.node.mediaDetails.sizes, "img-8080");
        }

        return /*#__PURE__*/Object(jsx_runtime["jsx"])(_StyledImageContainer, {
          _css: teaserImage.sourceUrl
        }, "teaser-img-".concat(node.id));
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h1", {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: "/tag/".concat(tagResult.slug),
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
          children: tagResult.name
        })
      })
    })]
  });
};

/* harmony default export */ var PostList_TagTeaser = (TagTeaser_TagTeaser);
// EXTERNAL MODULE: ./lib/graphql/allPostsQuery.js
var allPostsQuery = __webpack_require__("KMK3");

// CONCATENATED MODULE: ./components/PostList.js

















var CalendarWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostList__CalendarWrapper",
  componentId: "sc-64b774-0"
})(["padding-top:4rem;max-width:", ";margin:0 auto;text-align:center;"], function (props) {
  return props.theme.maxWidth;
});

var PostList_PostList = function PostList() {
  var tag = "modetrends-2024";
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(jsx_runtime["Fragment"], {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(react_components_esm["b" /* Query */], {
      query: allPostsQuery["a" /* ALL_POSTS_QUERY */],
      variables: {
        withTag: true
      },
      children: function children(_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data,
            fetchMore = _ref.fetchMore;
        if (error) return /*#__PURE__*/Object(jsx_runtime["jsx"])(ErrorMessage["a" /* default */], {
          message: "Error loading posts."
        });
        if (loading) return /*#__PURE__*/Object(jsx_runtime["jsx"])(Loading["a" /* default */], {});
        var posts = data.posts;
        return /*#__PURE__*/Object(jsx_runtime["jsx"])(PostGrid["a" /* default */], {
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(react_infinite_scroller_default.a, {
            hasMore: posts.pageInfo.hasNextPage,
            loadMore: function loadMore() {
              fetchMore({
                variables: {
                  cursor: posts.pageInfo.endCursor
                },
                updateQuery: function updateQuery(previousResult, _ref2) {
                  var fetchMoreResult = _ref2.fetchMoreResult;
                  var newEdges = fetchMoreResult.posts.edges;
                  var pageInfo = fetchMoreResult.posts.pageInfo;
                  return newEdges.length ? {
                    posts: {
                      __typename: previousResult.posts.__typename,
                      edges: [].concat(Object(toConsumableArray["a" /* default */])(previousResult.posts.edges), Object(toConsumableArray["a" /* default */])(newEdges)),
                      pageInfo: pageInfo
                    }
                  } : previousResult;
                }
              });
            },
            children: posts.edges.map(function (post, index) {
              return /*#__PURE__*/Object(jsx_runtime["jsxs"])(react_default.a.Fragment, {
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(Teaser["a" /* default */], {
                  post: post.node,
                  position: index % 2 === 0 ? "left" : "right"
                }, "post-".concat(post.node.id)), index === 2 && /*#__PURE__*/Object(jsx_runtime["jsx"])(PostList_WeSelect, {}, "after-".concat(post.node.id)), index === 6 && /*#__PURE__*/Object(jsx_runtime["jsx"])(Newsletter["a" /* default */], {}, "after-".concat(post.node.id)), index === 4 && /*#__PURE__*/Object(jsx_runtime["jsx"])(PostList_TagTeaser, {
                  tagName: tag
                }, "after-".concat(post.node.id)), index === 3 && /*#__PURE__*/Object(jsx_runtime["jsx"])(Ticker["a" /* default */], {}, "after-".concat(post.node.id))]
              }, "fragment-".concat(post.node.id));
            })
          })
        });
      }
    })
  });
};

/* harmony default export */ var components_PostList = (PostList_PostList);
{
  /* {locale === "de" && (
        <CalendarWrapper>
          <Calendar />
        </CalendarWrapper>
      )} */
}
// CONCATENATED MODULE: ./pages/index.js



var pages_Home = function Home() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(components_PostList, {});
};

/* harmony default export */ var pages = __webpack_exports__["default"] = (pages_Home);

/***/ }),

/***/ "SevZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _stringHash = _interopRequireDefault(__webpack_require__("9kyW"));

var _stylesheet = _interopRequireDefault(__webpack_require__("bVZc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sanitize = function sanitize(rule) {
  return rule.replace(/\/style/gi, '\\/style');
};

var StyleSheetRegistry = /*#__PURE__*/function () {
  function StyleSheetRegistry(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$styleSheet = _ref.styleSheet,
        styleSheet = _ref$styleSheet === void 0 ? null : _ref$styleSheet,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? false : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    this._sheet = styleSheet || new _stylesheet["default"]({
      name: 'styled-jsx',
      optimizeForSpeed: optimizeForSpeed
    });

    this._sheet.inject();

    if (styleSheet && typeof optimizeForSpeed === 'boolean') {
      this._sheet.setOptimizeForSpeed(optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    this._isBrowser = isBrowser;
    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
    this.computeId = this.createComputeId();
    this.computeSelector = this.createComputeSelector();
  }

  var _proto = StyleSheetRegistry.prototype;

  _proto.add = function add(props) {
    var _this = this;

    if (undefined === this._optimizeForSpeed) {
      this._optimizeForSpeed = Array.isArray(props.children);

      this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    if (this._isBrowser && !this._fromServer) {
      this._fromServer = this.selectFromServer();
      this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
        acc[tagName] = 0;
        return acc;
      }, {});
    }

    var _this$getIdAndRules = this.getIdAndRules(props),
        styleId = _this$getIdAndRules.styleId,
        rules = _this$getIdAndRules.rules; // Deduping: just increase the instances count.


    if (styleId in this._instancesCounts) {
      this._instancesCounts[styleId] += 1;
      return;
    }

    var indices = rules.map(function (rule) {
      return _this._sheet.insertRule(rule);
    }) // Filter out invalid rules
    .filter(function (index) {
      return index !== -1;
    });
    this._indices[styleId] = indices;
    this._instancesCounts[styleId] = 1;
  };

  _proto.remove = function remove(props) {
    var _this2 = this;

    var _this$getIdAndRules2 = this.getIdAndRules(props),
        styleId = _this$getIdAndRules2.styleId;

    invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
    this._instancesCounts[styleId] -= 1;

    if (this._instancesCounts[styleId] < 1) {
      var tagFromServer = this._fromServer && this._fromServer[styleId];

      if (tagFromServer) {
        tagFromServer.parentNode.removeChild(tagFromServer);
        delete this._fromServer[styleId];
      } else {
        this._indices[styleId].forEach(function (index) {
          return _this2._sheet.deleteRule(index);
        });

        delete this._indices[styleId];
      }

      delete this._instancesCounts[styleId];
    }
  };

  _proto.update = function update(props, nextProps) {
    this.add(nextProps);
    this.remove(props);
  };

  _proto.flush = function flush() {
    this._sheet.flush();

    this._sheet.inject();

    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
    this.computeId = this.createComputeId();
    this.computeSelector = this.createComputeSelector();
  };

  _proto.cssRules = function cssRules() {
    var _this3 = this;

    var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
      return [styleId, _this3._fromServer[styleId]];
    }) : [];

    var cssRules = this._sheet.cssRules();

    return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
      return [styleId, _this3._indices[styleId].map(function (index) {
        return cssRules[index].cssText;
      }).join(_this3._optimizeForSpeed ? '' : '\n')];
    }) // filter out empty rules
    .filter(function (rule) {
      return Boolean(rule[1]);
    }));
  }
  /**
   * createComputeId
   *
   * Creates a function to compute and memoize a jsx id from a basedId and optionally props.
   */
  ;

  _proto.createComputeId = function createComputeId() {
    var cache = {};
    return function (baseId, props) {
      if (!props) {
        return "jsx-" + baseId;
      }

      var propsToString = String(props);
      var key = baseId + propsToString; // return `jsx-${hashString(`${baseId}-${propsToString}`)}`

      if (!cache[key]) {
        cache[key] = "jsx-" + (0, _stringHash["default"])(baseId + "-" + propsToString);
      }

      return cache[key];
    };
  }
  /**
   * createComputeSelector
   *
   * Creates a function to compute and memoize dynamic selectors.
   */
  ;

  _proto.createComputeSelector = function createComputeSelector(selectoPlaceholderRegexp) {
    if (selectoPlaceholderRegexp === void 0) {
      selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    }

    var cache = {};
    return function (id, css) {
      // Sanitize SSR-ed CSS.
      // Client side code doesn't need to be sanitized since we use
      // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
      if (!this._isBrowser) {
        css = sanitize(css);
      }

      var idcss = id + css;

      if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
      }

      return cache[idcss];
    };
  };

  _proto.getIdAndRules = function getIdAndRules(props) {
    var _this4 = this;

    var css = props.children,
        dynamic = props.dynamic,
        id = props.id;

    if (dynamic) {
      var styleId = this.computeId(id, dynamic);
      return {
        styleId: styleId,
        rules: Array.isArray(css) ? css.map(function (rule) {
          return _this4.computeSelector(styleId, rule);
        }) : [this.computeSelector(styleId, css)]
      };
    }

    return {
      styleId: this.computeId(id),
      rules: Array.isArray(css) ? css : [css]
    };
  }
  /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */
  ;

  _proto.selectFromServer = function selectFromServer() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
    return elements.reduce(function (acc, element) {
      var id = element.id.slice(2);
      acc[id] = element;
      return acc;
    }, {});
  };

  return StyleSheetRegistry;
}();

exports["default"] = StyleSheetRegistry;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheetRegistry: " + message + ".");
  }
}

/***/ }),

/***/ "VUBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MX0m");
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);




var ErrorMessage = function ErrorMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsxs"])("aside", {
    className: "jsx-160792485",
    children: [message, /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a, {
      id: "160792485",
      children: ["aside.jsx-160792485{padding:1.5em;font-size:14px;color:white;background-color:red;}"]
    })]
  });
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorMessage);

/***/ }),

/***/ "Y8fK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");

// EXTERNAL MODULE: ./node_modules/jsonp/index.js
var jsonp = __webpack_require__("8ujH");
var jsonp_default = /*#__PURE__*/__webpack_require__.n(jsonp);

// EXTERNAL MODULE: ./node_modules/to-querystring/lib/to-querystring.min.js
var to_querystring_min = __webpack_require__("L+h+");
var to_querystring_min_default = /*#__PURE__*/__webpack_require__.n(to_querystring_min);

// CONCATENATED MODULE: ./node_modules/react-mailchimp-subscribe/es/SimpleForm.js


// a basic form
var SimpleForm_SimpleForm = function SimpleForm(_ref) {
  var status = _ref.status,
      message = _ref.message,
      className = _ref.className,
      style = _ref.style,
      onSubmitted = _ref.onSubmitted;

  var input = void 0;
  var submit = function submit() {
    return input && input.value.indexOf("@") > -1 && onSubmitted({
      EMAIL: input.value
    });
  };

  return react_default.a.createElement(
    "div",
    { className: className, style: style },
    status === "sending" && react_default.a.createElement(
      "div",
      { style: { color: "blue" } },
      "sending..."
    ),
    status === "error" && react_default.a.createElement("div", {
      style: { color: "red" },
      dangerouslySetInnerHTML: { __html: message }
    }),
    status === "success" && react_default.a.createElement("div", {
      style: { color: "green" },
      dangerouslySetInnerHTML: { __html: message }
    }),
    react_default.a.createElement("input", {
      ref: function ref(node) {
        return input = node;
      },
      type: "email",
      placeholder: "Your email"
    }),
    react_default.a.createElement(
      "button",
      { onClick: submit },
      "Submit"
    )
  );
};

/* harmony default export */ var es_SimpleForm = (SimpleForm_SimpleForm);
// CONCATENATED MODULE: ./node_modules/react-mailchimp-subscribe/es/index.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var getAjaxUrl = function getAjaxUrl(url) {
  return url.replace("/post?", "/post-json?");
};

var es_MailchimpSubscribe = function (_React$Component) {
  _inherits(MailchimpSubscribe, _React$Component);

  function MailchimpSubscribe() {
    var _temp, _this, _ret;

    _classCallCheck(this, MailchimpSubscribe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      status: null,
      message: null
    }, _this.subscribe = function (data) {
      var params = to_querystring_min_default()(data);
      var url = getAjaxUrl(_this.props.url) + "&" + params;
      _this.setState({
        status: "sending",
        message: null
      }, function () {
        return jsonp_default()(url, {
          param: "c"
        }, function (err, data) {
          if (err) {
            _this.setState({
              status: "error",
              message: err
            });
          } else if (data.result !== "success") {
            _this.setState({
              status: "error",
              message: data.msg
            });
          } else {
            _this.setState({
              status: "success",
              message: data.msg
            });
          }
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MailchimpSubscribe.prototype.render = function render() {
    return this.props.render({
      subscribe: this.subscribe,
      status: this.state.status,
      message: this.state.message
    });
  };

  return MailchimpSubscribe;
}(react_default.a.Component);

es_MailchimpSubscribe.propTypes =  false ? undefined : {};

es_MailchimpSubscribe.defaultProps = {
  render: function render(_ref) {
    var subscribe = _ref.subscribe,
        status = _ref.status,
        message = _ref.message;
    return react_default.a.createElement(es_SimpleForm, {
      status: status,
      message: message,
      onSubmitted: function onSubmitted(formData) {
        return subscribe(formData);
      }
    });
  }
};

/* harmony default export */ var es = (es_MailchimpSubscribe);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/rebass/dist/index.js
var dist = __webpack_require__("QKO/");

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__("dDsW");

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__("kriW");

// CONCATENATED MODULE: ./components/PostList/Newsletter.js







var Newsletter_url = "https://modepilot.us10.list-manage.com/subscribe/post?u=bcfede79c3f97eebae62a30cc&amp;id=096b5b0c68";
var Form = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Newsletter__Form",
  componentId: "sc-1hfg29d-0"
})(["padding:20px;@media screen and (max-width:500px){padding:10px 20px;}font-size:1.5rem;line-height:1.5;label{margin:2rem 0;}input,textarea{width:100%;margin-top:1rem;padding:1rem;font-size:2rem;@media screen and (max-width:500px){margin-top:0.5rem;}border:1px solid black;&:focus{outline:0;border-color:", ";}}button,input[type=\"submit\"]{width:auto;background:", ";color:", ";border:0;font-size:2rem;padding:0.5rem 1.2rem;}fieldset{border:0;padding:0;margin-bottom:2rem;&[disabled]{opacity:0.5;}.user-info{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:3rem;@media screen and (max-width:500px){grid-gap:1.5rem;}@media screen and (max-width:500px){grid-template-columns:1fr;}}}"], function (props) {
  return props.theme.highlight;
}, function (props) {
  return props.theme.colors.highlight;
}, function (props) {
  return props.theme.colors.white;
});
var NewsletterWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Newsletter__NewsletterWrapper",
  componentId: "sc-1hfg29d-1"
})(["max-width:", ";margin:auto;padding:30px 10px;@media screen and (max-width:500px){padding:10px 10px;}"], function (props) {
  return props.theme.maxWidth;
});

var Newsletter_CustomForm = function CustomForm(_ref) {
  var status = _ref.status,
      message = _ref.message,
      onValidated = _ref.onValidated;
  var intl = Object(useIntl["a" /* default */])();
  var email, fname, lname;

  var submit = function submit() {
    return email && fname && lname && email.value.indexOf("@") > -1 && onValidated({
      EMAIL: email.value,
      FNAME: fname.value,
      LNAME: lname.value
    });
  };

  var firstnameTranslated = intl.formatMessage({
    id: "newletter.firstname",
    defaultMessage: "Vorname"
  });
  var lastnameTranslated = intl.formatMessage({
    id: "newletter.lastname",
    defaultMessage: "Nachname"
  });
  var emailTranslated = intl.formatMessage({
    id: "newletter.email",
    defaultMessage: "E-Mail"
  });
  var sendingTranslated = intl.formatMessage({
    id: "newletter.sending",
    defaultMessage: "Einen Moment..."
  });
  var subscribeNowTranslated = intl.formatMessage({
    id: "newsletter.subscribe",
    defaultMessage: "Jetzt abonnieren!"
  });

  if (status === "success") {
    return /*#__PURE__*/Object(jsx_runtime["jsx"])(dist["Text"], {
      textAlign: "center",
      m: "3",
      fontSize: "3",
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(components_message["a" /* default */], {
        id: "email.success",
        defaultMessage: "Gleich haben wir es: Bitte best\xE4tige die Anmeldung mit der E-Mail, die wir Dir gerade geschickt haben."
      })
    });
  }

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(Form, {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("fieldset", {
      disabled: status === "sending",
      "aria-busy": status === "sending",
      children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "user-info",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("label", {
            htmlFor: "fname",
            children: firstnameTranslated
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("input", {
            ref: function ref(node) {
              return fname = node;
            },
            name: "fname",
            id: "fname",
            type: "text",
            placeholder: firstnameTranslated
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("label", {
            htmlFor: "lname",
            children: lastnameTranslated
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("input", {
            ref: function ref(node) {
              return lname = node;
            },
            type: "text",
            id: "lname",
            name: "lname",
            placeholder: lastnameTranslated
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("label", {
            htmlFor: "email",
            children: emailTranslated
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("input", {
            ref: function ref(node) {
              return email = node;
            },
            type: "email",
            id: "email",
            name: "email",
            placeholder: emailTranslated
          })]
        })]
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(dist["Flex"], {
      as: "fieldset",
      disabled: status === "sending",
      "aria-busy": status === "sending",
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(dist["Box"], {
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])("button", {
          onClick: submit,
          children: status === "sending" ? sendingTranslated : subscribeNowTranslated
        })
      }), status === "error" && /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        style: {
          color: "red"
        },
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), status === "success" && /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        style: {
          color: "green"
        },
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])(dist["Box"], {})]
    })]
  });
};

var Newsletter_Newsletter = function Newsletter(_ref2) {
  var _ref2$showDisclaimer = _ref2.showDisclaimer,
      showDisclaimer = _ref2$showDisclaimer === void 0 ? true : _ref2$showDisclaimer;
  var intl = Object(useIntl["a" /* default */])();
  var noWorriesTranslated = intl.formatMessage({
    id: "newsletter.no-worries",
    defaultMessage: "(Keine Angst, wir versenden nur monatlich)"
  });
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(NewsletterWrapper, {
    children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(dist["Heading"], {
      fontFamily: "serif",
      textAlign: "center",
      fontSize: "4",
      m: "3",
      as: "h1",
      letterSpacing: "2px",
      lineHeight: "copy",
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("img", {
        src: "/logo-small.png",
        alt: "MODEPILOT"
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("br", {}), "Newsletter"]
    }), showDisclaimer && /*#__PURE__*/Object(jsx_runtime["jsx"])(dist["Text"], {
      fontFamily: "serif",
      textAlign: "center",
      fontSize: "1",
      m: "2",
      children: noWorriesTranslated
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(es, {
      url: Newsletter_url,
      render: function render(_ref3) {
        var subscribe = _ref3.subscribe,
            status = _ref3.status,
            message = _ref3.message;
        return /*#__PURE__*/Object(jsx_runtime["jsx"])(Newsletter_CustomForm, {
          status: status,
          message: message,
          onValidated: function onValidated(formData) {
            return subscribe(formData);
          }
        });
      }
    })]
  });
};

/* harmony default export */ var PostList_Newsletter = __webpack_exports__["a"] = (Newsletter_Newsletter);

/***/ }),

/***/ "bVZc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

exports.__esModule = true;
exports["default"] = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/
var isProd = typeof process !== 'undefined' && process.env && "production" === 'production';

var isString = function isString(o) {
  return Object.prototype.toString.call(o) === '[object String]';
};

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'stylesheet' : _ref$name,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? isProd : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    invariant(isString(name), '`name` must be a string');
    this._name = name;
    this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
    invariant(typeof optimizeForSpeed === 'boolean', '`optimizeForSpeed` must be a boolean');
    this._optimizeForSpeed = optimizeForSpeed;
    this._isBrowser = isBrowser;
    this._serverSheet = undefined;
    this._tags = [];
    this._injected = false;
    this._rulesCount = 0;
    var node = this._isBrowser && document.querySelector('meta[property="csp-nonce"]');
    this._nonce = node ? node.getAttribute('content') : null;
  }

  var _proto = StyleSheet.prototype;

  _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
    invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean');
    invariant(this._rulesCount === 0, 'optimizeForSpeed cannot be when rules have already been inserted');
    this.flush();
    this._optimizeForSpeed = bool;
    this.inject();
  };

  _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
    return this._optimizeForSpeed;
  };

  _proto.inject = function inject() {
    var _this = this;

    invariant(!this._injected, 'sheet already injected');
    this._injected = true;

    if (this._isBrowser && this._optimizeForSpeed) {
      this._tags[0] = this.makeStyleTag(this._name);
      this._optimizeForSpeed = 'insertRule' in this.getSheet();

      if (!this._optimizeForSpeed) {
        if (!isProd) {
          console.warn('StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.');
        }

        this.flush();
        this._injected = true;
      }

      return;
    }

    this._serverSheet = {
      cssRules: [],
      insertRule: function insertRule(rule, index) {
        if (typeof index === 'number') {
          _this._serverSheet.cssRules[index] = {
            cssText: rule
          };
        } else {
          _this._serverSheet.cssRules.push({
            cssText: rule
          });
        }

        return index;
      },
      deleteRule: function deleteRule(index) {
        _this._serverSheet.cssRules[index] = null;
      }
    };
  };

  _proto.getSheetForTag = function getSheetForTag(tag) {
    if (tag.sheet) {
      return tag.sheet;
    } // this weirdness brought to you by firefox


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        return document.styleSheets[i];
      }
    }
  };

  _proto.getSheet = function getSheet() {
    return this.getSheetForTag(this._tags[this._tags.length - 1]);
  };

  _proto.insertRule = function insertRule(rule, index) {
    invariant(isString(rule), '`insertRule` accepts only strings');

    if (!this._isBrowser) {
      if (typeof index !== 'number') {
        index = this._serverSheet.cssRules.length;
      }

      this._serverSheet.insertRule(rule, index);

      return this._rulesCount++;
    }

    if (this._optimizeForSpeed) {
      var sheet = this.getSheet();

      if (typeof index !== 'number') {
        index = sheet.cssRules.length;
      } // this weirdness for perf, and chrome's weird bug
      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule


      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        }

        return -1;
      }
    } else {
      var insertionPoint = this._tags[index];

      this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
    }

    return this._rulesCount++;
  };

  _proto.replaceRule = function replaceRule(index, rule) {
    if (this._optimizeForSpeed || !this._isBrowser) {
      var sheet = this._isBrowser ? this.getSheet() : this._serverSheet;

      if (!rule.trim()) {
        rule = this._deletedRulePlaceholder;
      }

      if (!sheet.cssRules[index]) {
        // @TBD Should we throw an error?
        return index;
      }

      sheet.deleteRule(index);

      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        } // In order to preserve the indices we insert a deleteRulePlaceholder


        sheet.insertRule(this._deletedRulePlaceholder, index);
      }
    } else {
      var tag = this._tags[index];
      invariant(tag, "old rule at index `" + index + "` not found");
      tag.textContent = rule;
    }

    return index;
  };

  _proto.deleteRule = function deleteRule(index) {
    if (!this._isBrowser) {
      this._serverSheet.deleteRule(index);

      return;
    }

    if (this._optimizeForSpeed) {
      this.replaceRule(index, '');
    } else {
      var tag = this._tags[index];
      invariant(tag, "rule at index `" + index + "` not found");
      tag.parentNode.removeChild(tag);
      this._tags[index] = null;
    }
  };

  _proto.flush = function flush() {
    this._injected = false;
    this._rulesCount = 0;

    if (this._isBrowser) {
      this._tags.forEach(function (tag) {
        return tag && tag.parentNode.removeChild(tag);
      });

      this._tags = [];
    } else {
      // simpler on server
      this._serverSheet.cssRules = [];
    }
  };

  _proto.cssRules = function cssRules() {
    var _this2 = this;

    if (!this._isBrowser) {
      return this._serverSheet.cssRules;
    }

    return this._tags.reduce(function (rules, tag) {
      if (tag) {
        rules = rules.concat(Array.prototype.map.call(_this2.getSheetForTag(tag).cssRules, function (rule) {
          return rule.cssText === _this2._deletedRulePlaceholder ? null : rule;
        }));
      } else {
        rules.push(null);
      }

      return rules;
    }, []);
  };

  _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
    if (cssString) {
      invariant(isString(cssString), 'makeStyleTag acceps only strings as second parameter');
    }

    var tag = document.createElement('style');
    if (this._nonce) tag.setAttribute('nonce', this._nonce);
    tag.type = 'text/css';
    tag.setAttribute("data-" + name, '');

    if (cssString) {
      tag.appendChild(document.createTextNode(cssString));
    }

    var head = document.head || document.getElementsByTagName('head')[0];

    if (relativeToTag) {
      head.insertBefore(tag, relativeToTag);
    } else {
      head.appendChild(tag);
    }

    return tag;
  };

  _createClass(StyleSheet, [{
    key: "length",
    get: function get() {
      return this._rulesCount;
    }
  }]);

  return StyleSheet;
}();

exports["default"] = StyleSheet;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheet: " + message + ".");
  }
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("8oxB")))

/***/ }),

/***/ "vlRD":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("RNiq");
      }
    ]);
  

/***/ })

},[[14,0,1,2,3,4,5,7,6,8,10,9,11,12]]]);